import React from 'react';
import TechButton from './TechButton';

/**
 * Full-screen safety alert overlay.
 * Red for danger (stop work), orange for warning (caution).
 */
export default function SafetyAlert({ alert, onDismiss, t }) {
  if (!alert) return null;

  const isDanger = alert.action === 'stop_work';

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: isDanger ? 'rgba(214,48,49,0.95)' : 'rgba(253,203,110,0.95)',
      color: isDanger ? '#fff' : '#1a1a2e',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 32,
      zIndex: 1000,
      textAlign: 'center',
    }}>
      <div style={{ fontSize: 64, marginBottom: 16 }}>
        {isDanger ? '\u26D4' : '\u26A0\uFE0F'}
      </div>
      <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 12 }}>
        {isDanger ? (t?.dangerStop || 'DANGER - STOP WORK') : (t?.safety || 'SAFETY WARNING')}
      </h2>
      <p style={{ fontSize: 18, marginBottom: 24, maxWidth: 300, lineHeight: 1.5 }}>
        {alert.voice || alert.message}
      </p>
      {!isDanger && (
        <TechButton
          variant="secondary"
          onClick={onDismiss}
        >
          {t?.understood || 'Understood'}
        </TechButton>
      )}
    </div>
  );
}
